import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// import { FormattedMessage } from 'react-intl';
// import { phoneNormalize } from 'shared/modules';
// import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';

import Link from 'shared/components/Link/Link';
import { getPrice } from 'shared/helpers/advert';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import { fireRTBEvent } from 'shared/helpers/rtbHouse';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import { withTranslate } from 'shared/hocs/withTranslate';
import withAdvertPhoneView from 'shared/hocs/withAdvertPhoneView';
import { ContactPhoneButton, Button } from 'shared/components/UI';
import DealerSocials from 'shared/components/DealerSocials/DealerSocials';
import ThanksBlock from 'shared/components/DealerServiceForm/ThanksBlock';
// import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import ModalWrapper from 'shared/components/ModalWrapper/ModalWrapper';

import { IsVerifiedElement, IsGuaranteedElement } from 'shared/components/Elements';
import DealerServiceForm from 'shared/components/DealerServiceForm/DealerServiceForm';
import { IncomminCallIcon, ExchangeIcon, TestDriveIcon } from 'shared/components/Icons';
import DealerServiceExchangeForm from 'shared/components/DealerServiceExchangeForm/DealerServiceExchangeForm';

// import locationPointImg from 'shared/assets/images/placeholder-filled-point.svg';

import s from './AdvertSellerDealer.css';

const isMobile = __APP__ === 'mobile';

class AdvertSellerDealer extends React.Component {
  static propTypes = {
    advertID: PropTypes.number,
    authorName: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    location: PropTypes.string.isRequired,
    // authorEmail: PropTypes.string,
    avatar: PropTypes.string,
    agency: PropTypes.shape(),
    advert: PropTypes.shape().isRequired,
    link: PropTypes.string,
    title: PropTypes.string.isRequired,
    prices: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    extraText: PropTypes.string,
    requestShowPhones: PropTypes.func.isRequired,
    messengers: PropTypes.arrayOf(PropTypes.shape()),
    sold: PropTypes.bool,
    active: PropTypes.number,
    setRatioImage: PropTypes.func.isRequired,
    isApprovePub: PropTypes.bool.isRequired,
    setDataLayer: PropTypes.func.isRequired,
    //
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    authorName: '',
    advertID: null,
    agency: null,
    avatar: null,
    link: null,
    extraText: null,
    phones: null,
    messengers: null,
    sold: false,
    active: 1,
    showCallBackModal: false,
    isVerified: null,
  };

  state = {
    showCallBackModal: false,
    showExchangeModal: false,
    showTestDriveModal: false,
  };

  onEmailSent = serviceType => {
    this.setState({ emailSent: true });
    setTimeout(() => {
      this.closeServiceModal();
    }, 5000);

    const eventName = {
      'Trade-in': 'formTradeIn',
      'Обратный звонок': 'formCallback',
      'Test-drive': 'formTestDrive',
    };
    const gtmEvent = EVENTS.DEALER_ADV[eventName[serviceType]];
    if (gtmEvent) this.props.setDataLayer(gtmEvent);
    fireRTBEvent(eventName[serviceType], {
      value: this.props.prices && getPrice(this.props.prices),
      ids: [this.props.advertID],
    });
  };

  handleExchange = () => {
    this.setState({ showExchangeModal: true });
    this.props.setDataLayer(EVENTS.DEALER_ADV.tradeIn);
  };

  handleTestDrive = () => {
    this.setState({ showTestDriveModal: true });
    this.props.setDataLayer(EVENTS.DEALER_ADV.testDrive);
  };

  handleShowPhoneClick = cb => {
    const { advertID, requestShowPhones } = this.props;
    if (advertID) {
      requestShowPhones(advertID, true, phones => cb(phones));
    }
    this.props.setDataLayer(EVENTS.DEALER_ADV.showNubmer);
  };

  handleIncommingCall = () => {
    this.setState({ showCallBackModal: true });
    this.props.setDataLayer(EVENTS.DEALER_ADV.callback);
  };

  closeServiceModal = () => {
    this.setState({
      emailSent: false,
      showCallBackModal: false,
      showExchangeModal: false,
      showTestDriveModal: false,
    });
  };

  render() {
    const {
      authorName,
      location,
      avatar,
      agency,
      link,
      extraText,
      sold,
      setRatioImage,
      active,
      isApprovePub,
      title,
      prices,
      advert,
      t,
    } = this.props;

    const isTradeIn = agency && agency.trade_in;
    const isVerified = agency && agency.is_verified;
    const isTestDrive = agency && agency.test_drive;
    const IsGuaranteed = agency && agency.association_guarantees;

    const avatarImg = avatar && setRatioImage(avatar.replace('http:', 'https:'), 40);
    const isDeactivated = (active === -2 || !active || sold) && !isApprovePub;
    const messengers =
      agency && agency.messengers && !!agency.messengers.length && agency.messengers;

    const advertInfo = {
      title,
      prices,
      photos: advert.photos,
      advertId: advert.id,
    };

    /*
    const locale = t('locale') === 'ru' ? '' : `${t('locale')}_`;
    const agreementLink = `/pdf/${locale}terms-of-use.pdf`; */
    const moreAdvsText = agency.adverts_count
      ? `${t('Еще')} ${agency.adverts_count} ${t('предложений')}`
      : '';
    const rootClass = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rootClass}>
        <div className={s.rowContainer}>
          {authorName &&
            <React.Fragment>
              <div className={s.titleBlock}>
                <div className={`${s.avatarBlock}`}>
                  {avatar && <img className={s.avatar} alt={''} src={avatarImg} />}
                </div>
                <div className={`${s.dealerInfo}`}>
                  <div className={s.greyText}>
                    <FormattedMessage id={'Продавец'} />
                  </div>
                  <Link to={link || null} className={s.authorName}>
                    {authorName}
                  </Link>
                </div>
              </div>
              <div className={s.statusesBlock}>
                <div className={s.statusesIcons}>
                  <IsVerifiedElement type={isMobile ? 'iconWithText' : 'icon'} />
                  <IsGuaranteedElement type={isMobile ? 'iconWithText' : 'icon'} />
                </div>
                {moreAdvsText &&
                  <Link to={link || null} className={link ? s.moreAdvsText : s.colAuto}>
                    {moreAdvsText}
                  </Link>}
              </div>
            </React.Fragment>}
        </div>

        {!isDeactivated &&
          <div className={s.flexColumnBlock}>
            <div className={s.flexRowBlock}>
              <Button
                theme="Transparent"
                text="Обратный звонок"
                Icon={IncomminCallIcon}
                className={s.incomminCall}
                onClick={this.handleIncommingCall}
              />
              <ContactPhoneButton loadPhones={this.handleShowPhoneClick} />
            </div>
            <div className={s.buttonsWrapper}>
              {isTradeIn &&
                <Button
                  theme="Transparent"
                  text="Обмен на моё авто"
                  Icon={ExchangeIcon}
                  className={s.exchangeButton}
                  onClick={this.handleExchange}
                />}
              {isTestDrive &&
                <Button
                  theme="Transparent"
                  text="Заявка на тест-драйв"
                  Icon={TestDriveIcon}
                  className={s.testDriveButton}
                  onClick={this.handleTestDrive}
                />}
            </div>

            {this.state.showCallBackModal &&
              <div>
                <ModalWrapper
                  toggleModal={this.closeServiceModal}
                  show={this.state.showCallBackModal}
                >
                  {this.state.emailSent
                    ? <ThanksBlock />
                    : <React.Fragment>
                        <h3 className={s.rootModalTitle}>
                          <FormattedMessage id="Обратный звонок" />
                        </h3>
                        <DealerServiceForm
                          dealerSlug={agency.slug}
                          service="Обратный звонок"
                          advertInfo={advertInfo}
                          onSent={() => this.onEmailSent('Обратный звонок')}
                        />
                        <p className={`${s.modalText} ${s.rootModalPolicy}`}>
                          <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_1" />
                          <br />
                          <Link className={s.modalTextLink}>
                            <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_2" />
                          </Link>
                        </p>
                      </React.Fragment>}
                </ModalWrapper>
              </div>}

            {this.state.showExchangeModal &&
              <div>
                <ModalWrapper
                  toggleModal={this.closeServiceModal}
                  show={this.state.showExchangeModal}
                >
                  {this.state.emailSent
                    ? <ThanksBlock />
                    : <React.Fragment>
                        <h3 className={s.rootModalTitle}>
                          <FormattedMessage id="Обмен на моё авто" />
                        </h3>
                        <DealerServiceExchangeForm
                          dealerSlug={agency.slug}
                          advertInfo={advertInfo}
                          service="Trade-in"
                          onSent={() => this.onEmailSent('Trade-in')}
                        />
                        <p className={`${s.modalText} ${s.rootModalPolicy}`}>
                          <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_1" />
                          <br />
                          <Link className={s.modalTextLink}>
                            {''}
                            <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_2" />
                          </Link>
                        </p>
                      </React.Fragment>}
                </ModalWrapper>
              </div>}
            {this.state.showTestDriveModal &&
              <div>
                <ModalWrapper
                  toggleModal={this.closeServiceModal}
                  show={this.state.showTestDriveModal}
                >
                  {this.state.emailSent
                    ? <ThanksBlock />
                    : <React.Fragment>
                        <h3 className={s.rootModalTitle}>
                          <FormattedMessage id="Заявка на тест-драйв" />
                        </h3>
                        <DealerServiceForm
                          dealerSlug={agency.slug}
                          service="Тест-драйв"
                          advertInfo={advertInfo}
                          onSent={() => this.onEmailSent('Тест драйв')}
                        />
                        <p className={`${s.modalText} ${s.rootModalPolicy}`}>
                          <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_1" />
                          <br />
                          <Link className={s.modalTextLink}>
                            <FormattedMessage id="USER_AGREEMENT_DLG_TITLE_2" />
                          </Link>
                        </p>
                      </React.Fragment>}
                </ModalWrapper>
              </div>}

            {messengers &&
              <div className={s.messengersBlock}>
                <DealerSocials messengers={messengers} />
              </div>}
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(
  connect(null, { setDataLayer })(
    withAdvertPhoneView(withPixelRatio(withTranslate(AdvertSellerDealer))),
  ),
);



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertSeller/AdvertSellerDealer.js